<div  *ngIf="this.userInfo!== null && this.userInfo.internalUser" class="wrapper">
    <div class="row">
        <div class="col-md-8">
            <ol class="breadcrumb">
                <li>
                    <a [routerLink]="['/admin/announcements']">Announcements</a>
                    / Create
                </li>
            </ol>
        </div>
        <div class="col-md-2">
            <button type="button" class="btn btn-default col-md-12" (click)="onCancel()">Cancel</button>
        </div>
        <div class="col-md-2">
            <button *ngIf="announcement.Form" type="button" class="btn btn-primary col-md-12" (click)="onSubmit()" [disabled]="!announcement.Form.valid">Submit</button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div><span class="red">* </span>Required Fields</div>
        </div>
    </div>
    <announcement #announcement [(announcement)]="model"></announcement>
</div>
<modal-component #cancelAnnouncement
                 (accept)="redirectToAnnouncements()"
                 [title]="cancelTitle"
                 [data]="{
        resizeOrClose:'close',
        okBtnTitle:'Continue',
        okBtnCssClass:'btn btn-primary',
        small:true,
        cancelBtnTitle: 'Cancel',
        resubmitBtnTitle: '',
        cancelBtnCssClass:'btn btn-primary'}">
    <div class="hml-source">{{sourceModalContent}}</div>
</modal-component>
